/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Partnerships_EyebrowInputs */

const en_directory_resources_partnerships_eyebrow = /** @type {(inputs: Directory_Resources_Partnerships_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partnerships`)
};

const zh_directory_resources_partnerships_eyebrow = /** @type {(inputs: Directory_Resources_Partnerships_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合作伙伴`)
};

/**
* | output |
* | --- |
* | "Partnerships" |
*
* @param {Directory_Resources_Partnerships_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_partnerships_eyebrow = /** @type {((inputs?: Directory_Resources_Partnerships_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Partnerships_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_partnerships_eyebrow(inputs)
	return zh_directory_resources_partnerships_eyebrow(inputs)
});
export { directory_resources_partnerships_eyebrow as "directory.resources.partnerships.eyebrow" }